// extracted by mini-css-extract-plugin
export default {"password":"CloudStorageAccountDetails_password__kUhK3","button":"CloudStorageAccountDetails_button__MxUTV","content_wrap":"CloudStorageAccountDetails_content_wrap__4tiUe"};